//Types
import {
  GET_QUIZ_CAMPAIGNS,
  GET_QUIZ_CAMPAIGN,
  INSERT_QUIZ_CAMPAIGN,
  UPDATE_QUIZ_CAMPAIGN,
  DELETE_QUIZ_CAMPAIGN,
  GET_QUIZ_FORM_OPTIONS,
  GET_QUIZZES,
  INSERT_QUIZ,
  UPDATE_QUIZ,
  DELETE_QUIZ,
  CLEAR_QUIZ_CAMPAIGN,
  GET_QUIZ_WINNERS,
} from "./quizCampaign.type";

//Define InitialState
const initialState = {
  campaigns: [],
  total: 0,
  campaign: null,
  quizzes: [],
  // Campaign summary returned alongside the quizzes (name, totalPeriods, rules).
  quizCampaign: null,
  // Declared winners, admin variant (carries email) — see getQuizWinners.
  winners: [],
  formOptions: {
    frequencies: [],
    statuses: [],
    rules: {},
    languages: [],
    defaultLanguage: "en",
    defaultOptionLabels: {},
  },
};

const quizCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_QUIZ_CAMPAIGNS:
      return {
        ...state,
        campaigns: action.payload.campaigns,
        total: action.payload.total,
      };

    case GET_QUIZ_CAMPAIGN:
      return { ...state, campaign: action.payload };

    case GET_QUIZ_FORM_OPTIONS:
      return { ...state, formOptions: action.payload };

    case INSERT_QUIZ_CAMPAIGN:
      return {
        ...state,
        campaigns: [action.payload, ...state.campaigns],
        total: state.total + 1,
      };

    case UPDATE_QUIZ_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.map((campaign) =>
          campaign._id === action.payload.id ? action.payload.data : campaign
        ),
        campaign:
          state.campaign && state.campaign._id === action.payload.id
            ? action.payload.data
            : state.campaign,
      };

    case DELETE_QUIZ_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.filter((campaign) => campaign._id !== action.payload),
        total: Math.max(0, state.total - 1),
      };

    case GET_QUIZZES:
      return { ...state, quizzes: action.payload.quizzes, quizCampaign: action.payload.campaign };

    case INSERT_QUIZ:
      // Keep the list ordered by week number without a refetch.
      return {
        ...state,
        quizzes: [...state.quizzes, action.payload].sort((a, b) => a.weekNumber - b.weekNumber),
      };

    case UPDATE_QUIZ:
      return {
        ...state,
        quizzes: state.quizzes
          .map((quiz) => (quiz._id === action.payload.id ? action.payload.data : quiz))
          .sort((a, b) => a.weekNumber - b.weekNumber),
      };

    case DELETE_QUIZ:
      return { ...state, quizzes: state.quizzes.filter((quiz) => quiz._id !== action.payload) };

    case GET_QUIZ_WINNERS:
      return { ...state, winners: action.payload };

    case CLEAR_QUIZ_CAMPAIGN:
      return { ...state, campaign: null, quizzes: [], quizCampaign: null, winners: [] };

    default:
      return state;
  }
};

export default quizCampaignReducer;
